export default "__VITE_ASSET__ewrGT9Jy__"